import React, { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

const AUTH_APP_URL = import.meta.env.VITE_AUTH_APP_URL || 'http://localhost:3000';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div />;
  }

  if (!isAuthenticated) {
    window.location.href = AUTH_APP_URL;
    return null;
  }

  return <>{children}</>;
}
